import { Injectable, EventEmitter } from '@angular/core'

@Injectable({ providedIn: 'root' })

export class ShowAanService {
    showAanDialog = new EventEmitter<boolean>(false);
}